<div class="form-group" [class.hidden]="canBeNamed">
  <div class="control-label">Label</div>
  <input [(ngModel)]="optionName" type="text" class="form-control" />
</div>
<div class="form-group">
  <div class="form-group-horizontal form-check">
    <input [(ngModel)]="showStyle" type="checkbox" class="form-check-input" />
    <div class="form-check-label">Style</div>
  </div>

  <div class="app-row" [class.hidden]="!showStyle">
    <div class="form-group-horizontal form-check">
      <input [(ngModel)]="isVisible" type="checkbox" class="form-check-input">
      <span class="far" [class.fa-eye]="isVisible" [class.fa-eye-slash]="!isVisible" ></span>
    </div>
    <div [class.hidden]="isPoint===false" class="form-group point-swatch-group">
      <app-attribute-option-point-swatch [attr.disabled]="visdisabled"  (click)="ToggleSymbols()" [color]="color" [symbol]="attributeSymbol"
        #pointSwatch>
      </app-attribute-option-point-swatch>
      <div [attr.disabled]="visdisabled"  class="symbol-caret" (click)="ToggleSymbols()">
        <span class="fas" [class.down-adj]="!showSymbols" [class.fa-caret-down]="!showSymbols"
          [class.fa-caret-up]="showSymbols"></span>
      </div>
    </div>

    <div [attr.disabled]="visdisabled" [class.hidden]="!isSegment" class="form-group line-swatch-group">
      <app-line-style-swatch [attr.disabled]="visdisabled"  #lineSwatch (keyup)="HandleSwatchKey($event)" (click)="ToggleDashes()"
        [thickness]="lineThickness" [color]="color" [dash]="selectedDash" fillColor="#EFEFEF" [width]="100"
        [height]="24">
      </app-line-style-swatch>
      <span (click)="ToggleDashes()" [attr.disabled]="visdisabled" class="drop-down-caret fas " [class.fa-caret-down]="showDashes===false"
        [class.fa-caret-up]="showDashes===true"></span>
    </div>
    <input [attr.disabled]="visdisabled" [(ngModel)]="color" type="color" class="form-control form-control-color" />
    <input [attr.disabled]="visdisabled" [(ngModel)]="color" type="text" class="form-control form-color-input" />

    <div class="form-group" [class.hidden]="!isSegment">
      <select [attr.disabled]="visdisabled"  class="form-select" [(ngModel)]="thickness">
        <option value="thin">Thin</option>
        <option value="medium">Medium</option>
        <option value="thick">Thick</option>


      </select>
    </div>
    <div  class="form-group" [class.hidden]="!isPoint">
      <select [attr.disabled]="visdisabled" class="form-select" [(ngModel)]="symbolSize">
        <option value="half">Small</option>
        <option value="normal">Medium</option>
        <option value="double">Large</option>

      </select>
    </div>

  </div>

</div>
<div>
  <div [class.hidden]="showDashes === false" class="app-row">
    <app-attribute-option-line-styler #lineSwatches (enters)="DashEntered($event)" (selections)="selectedDash = $event"
      [color]="color" [thickness]="lineThickness">
    </app-attribute-option-line-styler>
  </div>
  <div [class.hidden]="showSymbols === false" class="app-row">
    <app-attribute-option-point-styler [(symbol)]="attributeSymbol"
    (symbolEnters)="SymbolEntered()" [color]="color" [symbolSize]="symbolSize">
    </app-attribute-option-point-styler>
  </div>
</div>
<div class="form-group-horizontal form-check">
  <input class="form-check-input" [(ngModel)]="showPrices" type="checkbox">
  <label class="section-label form-check-label">Prices</label>
</div>
<div class="app-row" [class.hidden]="!showPrices">
  <div class="form-group-horizontal" *ngFor="let price of prices">
    <ng-container *ngIf="IsEntryPrice(price)">
      <label class="form-label" [innerText]="price.alias"></label>
      <input [ngModel]="GetCostValue(price)" (keyup)="SetCostValue(price,$event)" type="text" class="form-control" />
      <label *ngIf="price.units=='USD'" class="price-unit">USD</label>
    </ng-container>
  </div>
</div>
